export const EXPLORE_CHART_HEIGHT = 320;
export const EXPLORE_CHART_MIN_WIDTH = 320;

/** Pixel width for Explore SVG; must match the `width` attribute and viewBox. */
export function resolveExploreChartWidth(containerWidth: number): number {
  if (!Number.isFinite(containerWidth) || containerWidth <= 0) return 0;
  return Math.max(Math.round(containerWidth), EXPLORE_CHART_MIN_WIDTH);
}
